import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,
          LoadingController, Loading, AlertController  } from 'ionic-angular';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatabaseProvider } from '../../providers/database/database';
import { UIProvider } from '../../providers/ui/ui';

import { PickupItem } from '../pickup/pickupitem';
/**
 * Generated class for the PickupAddPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-pickup-add',
  templateUrl: 'pickup-add.html',
})
export class PickupAddPage {

  pickupForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, public navParams: NavParams,  
              public formBuilder: FormBuilder, public alertCtrl: AlertController,
              public loadingCtrl: LoadingController, public dbProvider: DatabaseProvider,
              public uiProvider: UIProvider) {

    this.pickupForm = formBuilder.group({
      contact: ['', Validators.compose([Validators.minLength(2), 
      Validators.required])],
      date: ['', Validators.compose([Validators.required])],
      price: ['', Validators.compose([Validators.required])],
      paid: [''],
      type: ['', Validators.compose([Validators.minLength(2)])],
      weight: ['', Validators.compose([Validators.required])],
      weightunit: ['', Validators.compose([Validators.minLength(1)])],
      notes: ['', Validators.compose([Validators.minLength(5)])]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PickupAddPage');
  }

  savePickup() {
    console.log('ionViewDidLoad PickupAddPage savePickup(...)');
    if (!this.pickupForm.valid){
      console.log(this.pickupForm.value);
      console.log('PickupAddPage user entry invalid(...)');
    } else {
      let aPickupItem : PickupItem = {
        contact : this.pickupForm.value.contact,
        date : this.pickupForm.value.date,
        notes : this.pickupForm.value.notes,
        price : this.pickupForm.value.price,
        paid : false,
        type : this.pickupForm.value.type,
        weight : this.pickupForm.value.weight,
        weightunit : this.pickupForm.value.weightunit,

        id : this.dbProvider.getDBId()
      }

      console.log('saving... ' + aPickupItem);
      this.dbProvider.savePickupItem(aPickupItem);
      this.uiProvider.presentToast( "Saved " + aPickupItem.weight
      + " " + aPickupItem.weightunit + " pickup of " +  + aPickupItem.type, 3000);
      this.navCtrl.pop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/pickup-add/pickup-add.ts